import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { PureOriginalService } from "../service/pure-original.service";
import { PureOriginalsMatchingDetailsModel } from "../models/PureOriginalsMatchingDetails-model";
import { PureOriginalMatchingModel } from "../models/PureOriginalMatching-model";
import { DownloadFileFromDatabaseService } from "../service/DownloadFileFromDatabase.service";
import { ToastrService } from "ngx-toastr";
import { Location } from "@angular/common";

@Component({
  selector: 'app-pure-originals-matching-details-table',
  templateUrl: './pure-originals-matching-details-table.component.html',
  styleUrls: ['./pure-originals-matching-details-table.component.css']
})
export class PureOriginalsMatchingDetailsTableComponent implements OnInit {


  public pureOriginalMatchingDetails = new PureOriginalMatchingModel();
  public displayedColumns: (keyof PureOriginalMatchingModel)[] = [];
  public pureOriginalsMatchingDetails: PureOriginalsMatchingDetailsModel[] = [];
  public versionId: number;
  public versionName: string;
  public dcf: string;
  private partiallyTuned: string;
  public ecuBuild: string;
  private tableName: string = "PURE_ORIGINAL_MATCHING";
  public filesToDownload: number[] = [];
  public ecuProducer: string;
  public sortColumn: keyof PureOriginalMatchingModel | '' = '';
  public sortDirection: 'asc' | 'desc' = 'asc';
  private originalPureOriginalsMatchingDetails: PureOriginalsMatchingDetailsModel[] = [];

  constructor(private route: ActivatedRoute, private router: Router, private pureOriginalsService: PureOriginalService, private downloadService: DownloadFileFromDatabaseService, private toastr: ToastrService, private location: Location) {
    this.route.queryParams.subscribe((params) => {
      this.partiallyTuned = params['partiallyTuned'];
      this.versionId = params['versionId'];
      this.dcf = params['dcf'];
      this.versionName = params['versionName'];
      this.ecuBuild = params['ecuBuild'];
      this.ecuProducer = params['ecuProducer'];
    })
  }

  ngOnInit() {
    this.pureOriginalsMatchingDetails = [];
    this.getTableHeaderNames();
    const isPartiallyTuned = this.partiallyTuned === 'true';

    if (!isPartiallyTuned) {
      this.getPureOriginalsByVersionId(this.versionId);
    } else {
      this.getPureOriginalPartiallyTunedByVersionId(this.versionId);
    }

  }


  getTableHeaderNames() {
    let objectKeys = Object.keys(this.pureOriginalMatchingDetails);
    for (let key of objectKeys) {
      this.displayedColumns.push(key as keyof PureOriginalMatchingModel)
    }
  };
  getPureOriginalPartiallyTunedByVersionId(versionId: number) {
    this.pureOriginalsService.getPartiallyTunedPureOriginalsByVersionId(versionId).subscribe(response => {
      this.originalPureOriginalsMatchingDetails = [...response];
      this.pureOriginalsMatchingDetails = [...response];
    })
  }
  getPureOriginalsByVersionId(versionId: number) {
    this.pureOriginalsService.getPureOriginalsByVersionId(versionId).subscribe(response => {
      this.originalPureOriginalsMatchingDetails = [...response];
      this.pureOriginalsMatchingDetails = [...response];
    })
  }

  onSearchInput(value: string) {
    if (value && value.trim() !== '') {
      this.pureOriginalsMatchingDetails = this.originalPureOriginalsMatchingDetails.filter(item =>
        item.versionWinOLSReference?.toLowerCase().includes(value.toLowerCase())
      );
    } else {
      this.pureOriginalsMatchingDetails = [...this.originalPureOriginalsMatchingDetails];
    }
  }
  onRefreshTable() {
    this.pureOriginalsMatchingDetails = [];
    this.pureOriginalsService.pageNumber.set(0);
    this.getPureOriginalsByVersionId(this.versionId);
  }
  onScroll() {
    // this.getPureOriginalsByVersionId(this.versionId);
  }

  onSort(column: keyof PureOriginalMatchingModel) {
    if (this.sortColumn === column) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortColumn = column;
      this.sortDirection = 'asc';
    }

    this.pureOriginalsMatchingDetails.sort((a, b) => {
      let valA = a[column as keyof PureOriginalsMatchingDetailsModel];
      let valB = b[column as keyof PureOriginalsMatchingDetailsModel];

      if (valA === valB) return 0;
      if (valA == null) return 1;
      if (valB == null) return -1;

      if (typeof valA === 'string' && typeof valB === 'string') {
        return this.sortDirection === 'asc'
          ? valA.localeCompare(valB)
          : valB.localeCompare(valA);
      }

      return this.sortDirection === 'asc'
        ? (valA < valB ? -1 : 1)
        : (valA > valB ? -1 : 1);
    });
  }

  downloadVersionFromPureOriginals(id: number, winOls: string) {


    this.filesToDownload.push(id);

    const toastObj = this.toastr.info(`Preparing your ${winOls} file...`, 'Preparing..', {
      disableTimeOut: true, progressBar: true, progressAnimation: 'increasing'
    });

    this.downloadService.downloadFileFromDatabase(id, this.tableName).subscribe(response => {

      const index = this.filesToDownload.indexOf(id);
      this.filesToDownload.splice(index);

      if (response.status === 200) {

        this.toastr.clear(toastObj.toastId);
        window.location.href = response.body.url;

        this.toastr.success(`<div><span>Your file ${winOls} is downloaded</span></div>`, "Success", {
          timeOut: 5000,
          closeButton: false,
        });
      }

    }, error => {
      this.toastr.clear(toastObj.toastId);
      this.toastr.error(`${error.error['message']}`, 'Failed', {
        disableTimeOut: false
      });
    })

  }
  openPureOriginalDetails(id: number) {
    this.router.navigate(['/app/pure-originals/pure-original-details'], { queryParams: { pureOriginalId: id } });
  }

  backToMainTable() {
    this.location.back();
  }

  formatDate(value: any, column: string): string {
    if (value == null || value === '') return '-';

    const dateColumns = ['date', 'dateUploaded', 'dateUpdated', 'dateExported', 'dateMatched', 'versionDateUploaded', 'dateuploaded'];
    if (dateColumns.includes(column)) {
      const parts = value.toString().split('-');
      if (parts.length < 6) return value;

      let year, month, day, hours, minutes, seconds;

      if (parseInt(parts[0], 10) > 12) {
        day = parseInt(parts[0], 10);
        month = parseInt(parts[1], 10) - 1;
        year = parseInt(parts[2], 10);
      } else if (parseInt(parts[1], 10) > 12) {
        month = parseInt(parts[0], 10) - 1;
        day = parseInt(parts[1], 10);
        year = parseInt(parts[2], 10);
      } else {
        if (column === 'dateuploaded') {
          month = parseInt(parts[0], 10) - 1;
          day = parseInt(parts[1], 10);
        } else {
          day = parseInt(parts[0], 10);
          month = parseInt(parts[1], 10) - 1;
        }
        year = parseInt(parts[2], 10);
      }

      hours = parseInt(parts[3], 10);
      minutes = parseInt(parts[4], 10);
      seconds = parseInt(parts[5], 10);

      const utcDate = new Date(Date.UTC(year, month, day, hours, minutes, seconds));

      if (isNaN(utcDate.getTime())) return value;

      const localDay = utcDate.getDate().toString().padStart(2, '0');
      const localMonth = (utcDate.getMonth() + 1).toString().padStart(2, '0');
      const localYear = utcDate.getFullYear();
      const localHours = utcDate.getHours().toString().padStart(2, '0');
      const localMinutes = utcDate.getMinutes().toString().padStart(2, '0');
      const localSeconds = utcDate.getSeconds().toString().padStart(2, '0');

      return `${localDay}-${localMonth}-${localYear} ${localHours}:${localMinutes}:${localSeconds}`;
    }

    if (column === 'hitRate' && typeof value === 'number') {
      return (value * 100).toFixed(2) + '%';
    }

    return value.toString();
  }
}
